const normalizeLotId = (lotId) => {
    if (!lotId) return [];
    return Array.isArray(lotId) ? lotId.filter(Boolean) : [lotId];
};

const createGroupKey = (rule) => JSON.stringify({
    clientId: rule.clientId,
    activityId: rule.activityId,
    bundleId: rule.bundleId,
    vehicleTypeIds: rule.vehicleTypeIds,
    calcOnCheckin: rule.calcOnCheckin,
    ruleOperand: rule.ruleOperand,
    daysToComplete: rule.daysToComplete,
    preferredVendorId: rule.preferredVendorId,
    calcOnFirstCheckin: rule.calcOnFirstCheckin,
    timeFrameType: rule.timeFrameType,
    ruleParams: rule.ruleParams?.map(({ paramType, paramSubType, paramOperator, paramValue }) => 
        ({ paramType, paramSubType, paramOperator, paramValue })
    ).sort((a, b) => a.paramType - b.paramType)
});

export const groupRulesByProperties = (rulesArray) => {
    if (!rulesArray?.length) return [];

    const grouped = {};

    for (const rule of rulesArray) {
        // allLots/allTenantLots don't need grouping
        if (rule.allLots || rule.allTenantLots) {
            grouped[rule.id] = { ...rule, originalIds: [rule.id] };
            continue;
        }

        const key = createGroupKey(rule);
        const lots = normalizeLotId(rule.lotId);

        if (!grouped[key]) {
            grouped[key] = {
                ...rule,
                lotId: new Set(lots),
                originalIds: [rule.id]
            };
        } else {
            lots.forEach(lot => grouped[key].lotId.add(lot));
            grouped[key].originalIds.push(rule.id);
        }
    }

    return Object.values(grouped).map(rule => {
        const lotIds = Array.from(rule.lotId);
        return { 
            ...rule, 
            lotId: lotIds.length === 1 ? lotIds[0] : lotIds 
        };
    });
};
